module.exports = __webpack_public_path__ + "img/partner1.1de8ae83.png";